export default function (state, getters, rootState, rootGetters) {
    let data = {};
    let rules = rootGetters['clients/item/rules/list'];
    if (!rules) return null;
    if (req(rules, 'PassportRusSer') && !state.PassportRusSer) return null;
    data.PassportRusSer = state.PassportRusSer;
    if (req(rules, 'PassportRusNumber') && !state.PassportRusNumber) return null;
    data.PassportRusNumber = state.PassportRusNumber;
    if (req(rules, 'PassportRusDate') && !state.PassportRusDate) return null;
    data.PassportRusDate = {Serialized: state.PassportRusDate};
    if (req(rules, 'PassportRusByWhom') && !state.PassportRusByWhom) return null;
    data.PassportRusByWhom = state.PassportRusByWhom;
    if (req(rules, 'PassportType') && !state.PassportType) return null;
    data.PassportType = state.PassportType;
    if (req(rules, 'PassportNumber') && !state.PassportNumber) return null;
    data.PassportNumber = state.PassportNumber;
    if (req(rules, 'PassportDate') && !state.PassportDate) return null;
    data.PassportDate = {Serialized: state.PassportDate};
    if (req(rules, 'PassportDateEnd') && !state.PassportDateEnd) return null;
    data.PassportDateEnd = {Serialized: state.PassportDateEnd};
    if (req(rules, 'PassportByWhom') && !state.PassportByWhom) return null;
    data.PassportByWhom = state.PassportByWhom;
    return data;
}

function req(rules, field) {
    return (rules[field] && rules[field][0] && rules[field][0].required)
}